
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  onOpenChange?: (open: boolean) => void;
}

const Logo: React.FC<LogoProps> = ({ className, onOpenChange }) => {
  return (
    <Link 
      to="/" 
      className={`flex items-center gap-2 transition-transform hover:scale-105 duration-200 ${className || ''}`}
      onClick={() => onOpenChange && onOpenChange(false)}
    >
      <div className="h-9 w-9 overflow-hidden rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-md">
        <span className="font-bold text-white text-lg">P</span>
      </div>
      <span className="font-bold text-lg bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">ParleyRide</span>
    </Link>
  );
};

export default Logo;
